// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__2HFlL","rowsWrapper":"style_rowsWrapper__uJ1h8","rowWrapper":"style_rowWrapper__3jMDN"};